<template>
          <b-col cols="12">
            <b-form-group 
                :label="$t(config.label)" 
                :state="null"
            >
              <flat-pickr
                  :state="null"
                  @input="(newValue)=> {

                      newValue = newValue.split(' to ')

                      $emit('updateRequest', {
                        key:config.startKey,
                        value:newValue[0]
                      })

                      $emit('updateRequest', {
                        key:config.endKey,
                        value:newValue[1]
                      })

                  }"
                  :value="[request[config.startKey], request[config.endKey]]"
                  class="form-control" 
                  :config="{
                      dateFormat: 'Y-m-d H:i:S',
                      enableTime: true,
                      enableSeconds: true,
                      defaultHour: 0,
                      mode: 'range',
                      time_24hr: true
                  }"
                  placeholder="YYYY-MM-DD HH:ii:ss" 
              />

              <b-form-invalid-feedback v-if="errors && (config.startKey in errors)" :state="errors && (config.startKey in errors) ? false : null">
                {{ $t(errors[config.startKey][0]) }}
              </b-form-invalid-feedback>

              <b-form-invalid-feedback v-if="errors && (config.endKey in errors)" :state="errors && (config.endKey in errors) ? false : null">
                {{ $t(errors[config.endKey][0]) }}
              </b-form-invalid-feedback>

            </b-form-group>
          </b-col>
</template>

<script>

import moment from 'moment'
import flatPickr from 'vue-flatpickr-component'
import { BCol, BFormGroup, BFormInvalidFeedback } from 'bootstrap-vue';

export default {
    components: {
      BCol,
      BFormGroup,
      flatPickr,
      BFormInvalidFeedback
    },
    emit:['updateRequest'],
    props: {
      config:{
        type:Object
      },
      data:{
        type:Object
      },
      request:{
        type:Object
      },
      errors:{
        type:Object
      }
    },
    setup(props, { emit }) {

        emit('updateRequest', { key:props.config.startKey, value:moment().hours(0).minutes(0).seconds(0).format('YYYY-MM-DD HH:mm:ss') })
        emit('updateRequest', { key:props.config.endKey, value:moment().hours(23).minutes(59).seconds(59).format('YYYY-MM-DD HH:mm:ss') })

        return {}
    }
}
</script>
